<template>
    <div class="ah-page bank-account-edit-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1 v-if="!sno">新增銀行帳戶</h1>
                        <h1 v-if="sno">編輯銀行帳戶</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="panel-header small gray">
                    <div class="panel-title">帳戶資訊</div>
                </div>
                <div class="panel-body">
                    <BankAccountForm ref="form" :permissionTyp="permissionTyp" :staffPermissions="staffPermissions" @fetch="onFetch" />
                </div>
            </div>
            <div v-if="isAuth('F03') && !isQR()" class="ah-panel">
                <div class="panel-header small gray">
                    <div class="panel-title">帳戶使用權</div>
                </div>
                <div class="panel-body">
                    <el-form label-position="right" label-width="210px" style="padding: 0 30px">
                        <el-form-item prop="authTyp" label="帳戶使用權">
                            <el-radio-group v-model="permissionTyp" class="radio-option-cards">
                                <el-radio :label="1" border style="width: 200px">
                                    <div class="icon">
                                        <i class="el-icon-check"></i>
                                    </div>
                                    <div class="title">不限定</div>
                                    <div class="intro" style="padding-bottom: 15px">有權限者皆可選取此帳戶</div>
                                </el-radio>
                                <template v-if="isPayed('F25')">
                                    <el-radio :label="2" border style="width: 200px">
                                        <div class="icon">
                                            <i class="el-icon-lock"></i>
                                        </div>
                                        <div class="title">限定使用者</div>
                                        <div class="intro" style="padding-bottom: 15px">僅限指定人員可選取此帳戶</div>
                                    </el-radio>
                                </template>
                                <template v-else>
                                    <ahRichPopInfo title="加購功能：限定使用者" content="此功能可讓您自訂能操作此帳戶的使用者，進行細部的權限控管。如需啟用此功能，請洽 Sokuji 業務團隊！" :width="300">
                                        <div style="display: inline-block;">
                                            <el-radio :label="2" border disabled style="width: 200px; pointer-events: none;">
                                                <div class="icon">
                                                    <i class="el-icon-lock"></i>
                                                </div>
                                                <div class="title">限定使用者 (未購買)</div>
                                                <div class="intro" style="padding-bottom: 15px">僅限指定人員可選取此帳戶</div>
                                            </el-radio>
                                        </div>
                                    </ahRichPopInfo>
                                </template>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item prop="staffs" v-if="permissionTyp === 2" label="">
                            <div style="display: flex; justify-content: end; gap: 10px; border-bottom: 1px solid #eee; padding: 0 0 20px">
                                <el-select
                                    class="text-cursor"
                                    v-model="staffSelections"
                                    placeholder="請選擇帳號"
                                    no-data-text="無資料"
                                    no-match-text="無相關資料"
                                    filterable
                                    multiple
                                    style="width: 50%"
                                >
                                    <el-option v-for="item in filteredStaffOptions" :key="item.sno" :label="item.nam" :value="item.sno">
                                        <div class="name">{{ item.nam }}</div>
                                    </el-option>
                                </el-select>
                                <el-button type="primary" icon="el-icon-plus" @click="addStaff">新增使用者</el-button>
                            </div>
                            <el-table :data="combinedStaffPermissions" style="width: 100%; margin-bottom: 20px" empty-text="無">
                                <el-table-column type="index" label="#" width="70"></el-table-column>
                                <el-table-column prop="staffName" label="姓名" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.staffName }}{{ scope.row.fixed ? " (銀行帳戶管理員)" : "" }}{{ scope.row.staffOnf === 0 ? "（已停用）" : "" }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="visibility" align="center">
                                    <template slot="header">檢視</template>
                                    <template slot-scope="scope">
                                        <el-checkbox :value="scope.row.permissions.includes(1)" :disabled="scope.row.fixed" @input="onPermissionInput(scope.row, 1)">帳戶明細</el-checkbox>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="functions">
                                    <template slot="header">使用功能</template>
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.fixed" style="color: #999">依帳號權限</span>
                                        <div v-else style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px 0px;">
                                            <el-tooltip :disabled="!!scope.row.hasA02" content="該帳號無此權限" placement="top" effect="light">
                                                <span style="display: inline-block;">
                                                    <el-checkbox :value="scope.row.permissions.includes(2)" :disabled="!scope.row.hasA02" @input="onPermissionInput(scope.row, 2)">請款單付款</el-checkbox>
                                                </span>
                                            </el-tooltip>
                                            <el-tooltip :disabled="!!scope.row.hasB03" content="該帳號無此權限" placement="top" effect="light">
                                                <span style="display: inline-block;">
                                                    <el-checkbox :value="scope.row.permissions.includes(3)" :disabled="!scope.row.hasB03" @input="onPermissionInput(scope.row, 3)">發票入帳/退款</el-checkbox>
                                                </span>
                                            </el-tooltip>
                                            <el-tooltip :disabled="!!scope.row.hasE01" content="該帳號無此權限" placement="top" effect="light">
                                                <span style="display: inline-block;">
                                                    <el-checkbox :value="scope.row.permissions.includes(4)" :disabled="!scope.row.hasE01" @input="onPermissionInput(scope.row, 4)">財務收支</el-checkbox>
                                                </span>
                                            </el-tooltip>
                                            <el-tooltip :disabled="!!scope.row.hasE01" content="該帳號無此權限" placement="top" effect="light">
                                                <span style="display: inline-block;">
                                                    <el-checkbox :value="scope.row.permissions.includes(5)" :disabled="!scope.row.hasE01" @input="onPermissionInput(scope.row, 5)">帳戶互轉</el-checkbox>
                                                </span>
                                            </el-tooltip>
                                            <el-tooltip :disabled="!!scope.row.hasE03" content="該帳號無此權限" placement="top" effect="light">
                                                <span style="display: inline-block;">
                                                    <el-checkbox :value="scope.row.permissions.includes(6)" :disabled="!scope.row.hasE03" @input="onPermissionInput(scope.row, 6)">人事薪資付款</el-checkbox>
                                                </span>
                                            </el-tooltip>
                                            <el-tooltip :disabled="!!scope.row.hasE02" content="該帳號無此權限" placement="top" effect="light">
                                                <span style="display: inline-block;">
                                                    <el-checkbox :value="scope.row.permissions.includes(7)" :disabled="!scope.row.hasE02" @input="onPermissionInput(scope.row, 7)">零用金轉入/轉出</el-checkbox>
                                                </span>
                                            </el-tooltip>
                                            <el-tooltip :disabled="!!scope.row.hasD22" content="該帳號無此權限" placement="top" effect="light">
                                                <span style="display: inline-block;">
                                                    <el-checkbox :value="scope.row.permissions.includes(8)" :disabled="!scope.row.hasD22" @input="onPermissionInput(scope.row, 8)">借款管理</el-checkbox>
                                                </span>
                                            </el-tooltip>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="action" label="" width="100">
                                    <template slot-scope="scope">
                                        <el-button v-if="!scope.row.fixed" size="small" @click="removeStaff(scope.row.staffId)" icon="el-icon-delete">移除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div style="text-align: center">
                <el-alert type="info" style="margin: 0 0 20px 0" :closable="false" v-if="!sno"> 銀行帳號、存摺戶名……等欄位儲存後不可修改，請再次確認資訊是否正確。 </el-alert>
                <el-tooltip content="如您要刪除該帳戶，請先清除所有用到該帳戶的資料（例如：請款單、發票、財務收支、人事薪資、零用金）" placement="top" :manual="!isUsed" style="margin-right: 10px">
                    <span>
                        <el-button v-if="sno" :disabled="isUsed || isQR()" type="danger" plain @click="onDelete"> 刪除 </el-button>
                    </span>
                </el-tooltip>
                <el-button @click="$router.push({ name: 'bank-account' })"> 取消 </el-button>
                <el-button v-if="!isQR()" type="primary" class="primary-action" style="width: 150px" @click="onSubmit">送出</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import BankAccountForm from './BankAccountForm.vue';

export default {
    name: 'BankAccountEditPage',
    components: { BankAccountForm },
    computed: {
        combinedStaffPermissions() {
            return [...this.fixedStaffPermissions, ...this.staffPermissions];
        },
        filteredStaffOptions() {
            return this.staffOptions.filter((staff) => !this.combinedStaffPermissions.some((member) => member.staffId === staff.sno));
        },
    },
    data() {
        return {
            sno: null,
            isUsed: false,
            staffOptions: [],
            staffSelections: [],
            fixedStaffPermissions: [],
            staffPermissions: [],
            permissionTyp: 1,
        };
    },
    async mounted() {
        if (this.isAuth('F03')) {
            this.staffOptions = await this.fetchStaffOptions();
            this.fixedStaffPermissions = await this.fetchFixedStaffOptions();
        }
    },
    methods: {
        onFetch({
            sno, isUsed, staffPermissions, permissionTyp,
        }) {
            this.sno = sno;
            this.isUsed = isUsed;
            this.staffPermissions = staffPermissions.map((s) => {
                const targetStaff = this.staffOptions.find((x) => x.sno === s.staffId);
                
                // 過濾掉其實不具備系統權限的項目，避免打勾與 disabled 發生衝突
                let validPermissions = s.permissions || [];
                if (targetStaff) {
                    validPermissions = validPermissions.filter((p) => {
                        if (p === 2 && !targetStaff.hasA02) return false;
                        if (p === 3 && !targetStaff.hasB03) return false;
                        if ((p === 4 || p === 5) && !targetStaff.hasE01) return false;
                        if (p === 6 && !targetStaff.hasE03) return false;
                        if (p === 7 && !targetStaff.hasE02) return false;
                        if (p === 8 && !targetStaff.hasD22) return false;
                        return true;
                    });
                }

                return {
                    ...s,
                    permissions: validPermissions,
                    hasA02: targetStaff?.hasA02 || false,
                    hasA03: targetStaff?.hasA03 || false,
                    hasB02: targetStaff?.hasB02 || false,
                    hasB03: targetStaff?.hasB03 || false,
                    hasD22: targetStaff?.hasD22 || false,
                    hasE01: targetStaff?.hasE01 || false,
                    hasE02: targetStaff?.hasE02 || false,
                    hasE03: targetStaff?.hasE03 || false,
                };
            });
            this.permissionTyp = permissionTyp;
        },
        goBackToList() {
            this.$router.push({ name: 'bank-account' });
        },
        onPermissionInput(row, input) {
            if (row.permissions.includes(input)) row.permissions = row.permissions.filter((x) => x !== input);
            else row.permissions.push(input);

            row.permissions.sort((a, b) => a - b);
        },

        onSubmit() {
            this.$refs.form.onSubmit(this.goBackToList);
        },

        async fetchStaffOptions() {
            const staffListResp = await this.$api({
                url: '/BankAccountSettingPage/GetManagerOptions',
                params: {
                    PageSize: 999,
                    PageNum: 1,
                    ONF: 1,
                },
                method: 'GET',
            });
            return staffListResp.data.options.filter((x) => !['SA', 'INI', 'ADM'].includes(x.grP_NO)).reverse();
        },
        async fetchFixedStaffOptions() {
            const f03StaffsResp = await this.$api({
                url: 'BankAccountSettingPage/getF03Staffs',
                method: 'GET',
            });
            return f03StaffsResp.data.f03Staffs.map((o) => ({
                fixed: true,
                staffId: o.sno,
                staffOnf: o.onf,
                staffName: o.nam,
                permissions: [1],
            }));
        },

        addStaff() {
            if (!this.staffPermissions) {
                this.staffPermissions = [];
            }

            this.staffSelections.forEach((sno) => {
                const staffData = this.staffOptions.find((x) => x.sno === sno);
                if (staffData) {
                    // 依照目前系統狀態賦予最大權限（預設不勾選無權限的功能）
                    const checkedPerms = [1];
                    if (staffData.hasA02) checkedPerms.push(2);
                    if (staffData.hasB03) checkedPerms.push(3);
                    if (staffData.hasE01) {
                        checkedPerms.push(4);
                        checkedPerms.push(5);
                    }
                    if (staffData.hasE03) checkedPerms.push(6);
                    if (staffData.hasE02) checkedPerms.push(7);
                    if (staffData.hasD22) checkedPerms.push(8);

                    this.staffPermissions.push({
                        staffId: staffData.sno,
                        staffName: staffData.nam,
                        permissions: checkedPerms,
                        hasA02: staffData.hasA02,
                        hasA03: staffData.hasA03,
                        hasB02: staffData.hasB02,
                        hasB03: staffData.hasB03,
                        hasD22: staffData.hasD22,
                        hasE01: staffData.hasE01,
                        hasE02: staffData.hasE02,
                        hasE03: staffData.hasE03,
                    });
                }
            });
            this.staffSelections = [];
        },
        removeStaff(sno) {
            this.staffPermissions = this.staffPermissions.filter((x) => x.staffId !== sno);
        },

        async onDelete() {
            try {
                await this.$confirm('確定要刪除帳戶？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });
                this.onConfirmDelete();
            } catch (e) {
                console.log(e);
            }
        },
        async onConfirmDelete() {
            await this.$api({
                url: '/BankAccountSettingPage/DeleteSetting',
                method: 'post',
                data: { id: this.sno },
            });

            this.goBackToList();
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";
</style>
